import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';

import { getActionTypesResult } from '../utils';

export const ARCHIVE = {
    DEVICES: `/devices/DeletedDevices`,
    DEVICES_ASSIGNMENT_REASONS: `/deviceAssignmentReason/deleted`,
    MOBILE_DEVICES: `/mobileDevices/DeletedMobileDevices`,
    LICENSES: `/licenses/deletedLicenses`,
    VIRTUAL_MACHINES: `/vm/deletedVirtualMachines`,
    LICENSE_PRODUCT_NAME: `/licenseProductName/deleted`,
    LICENSE_PRODUCT_VERSION: `/licenseProductVersion/deleted`,
    LICENSE_PRODUCT_ATTRIBUTE: `/licenseProductAttribute/deleted`
};

const archiveConstants = {
    ARCHIVE_LOADED: 'ARCHIVE_LOADED',
    ARCHIVE_RESTORE_DEVICE: 'ARCHIVE_RESTORE_DEVICE',
    ARCHIVE_RESTORE_DEVICES_ASSIGNMENT_REASONS: 'ARCHIVE_RESTORE_DEVICES_ASSIGNMENT_REASONS',
    ARCHIVE_RESTORE_LICENSE: 'ARCHIVE_RESTORE_LICENSE',
    ARCHIVE_RESTORE_LICENSE_PRODUCT_NAME: 'ARCHIVE_RESTORE_LICENSE_PRODUCT_NAME',
    ARCHIVE_RESTORE_LICENSE_PRODUCT_VERSION: 'ARCHIVE_RESTORE_LICENSE_PRODUCT_VERSION',
    ARCHIVE_RESTORE_LICENSE_PRODUCT_ATTRIBUTE: 'ARCHIVE_RESTORE_LICENSE_PRODUCT_ATTRIBUTE'
};

export const archiveFulfilledConstants = getActionTypesResult(archiveConstants, '_FULFILLED');
export const archivePendingConstants = getActionTypesResult(archiveConstants, '_PENDING');
export const archiveRejectedConstants = getActionTypesResult(archiveConstants, '_REJECTED');

export const fetchArchive = createAsyncAction(archiveConstants.ARCHIVE_LOADED, (deviceURL, queryParams) =>
    api.get(deviceURL, { params: queryParams, paramsSerializer: { indexes: null } }).then(res => res.data)
);

export const restoreDevice = createAsyncAction(archiveConstants.ARCHIVE_RESTORE_DEVICE, deviceId =>
    api.put(`devices/${deviceId}/restore`).then(res => res.data)
);

export const restoreDeviceAssignmentReason =
    createAsyncAction(archiveConstants.ARCHIVE_RESTORE_DEVICES_ASSIGNMENT_REASONS, reasonId =>
        api.put(`deviceAssignmentReason/${reasonId}/restore`).then(res => res.data)
    );

export const restoreLicense = createAsyncAction(archiveConstants.ARCHIVE_RESTORE_LICENSE, licenseId =>
    api.put(`licenses/${licenseId}/restore`).then(res => res.data)
);

export const restoreLicenseProductName = createAsyncAction(
    archiveConstants.ARCHIVE_RESTORE_LICENSE_PRODUCT_NAME, licenseProductNameId =>
        api.put(`licenseProductName/${licenseProductNameId}/restore`).then(res => res.data)
);

export const restoreLicenseProductVersion = createAsyncAction(
    archiveConstants.ARCHIVE_RESTORE_LICENSE_PRODUCT_VERSION, licenseProductVersionId =>
        api.put(`licenseProductVersion/${licenseProductVersionId}/restore`).then(res => res.data)
);

export const restoreLicenseProductAttribute = createAsyncAction(
    archiveConstants.ARCHIVE_RESTORE_LICENSE_PRODUCT_ATTRIBUTE, licenseProductAttributeId =>
        api.put(`licenseProductAttribute/${licenseProductAttributeId}/restore`).then(res => res.data)
);
